import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error) {
    Raven.captureException(error, {
      tags: {
        lib: 'xray-recommendation-lib'
      }
    });
  }
  render() {
    const {
      hasError
    } = this.state;
    if (!hasError) {
      return this.props.children || null;
    }
    return /*#__PURE__*/_jsx(ErrorMessage, {
      "data-test-id": "error-boundary",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.errors.generalError.title"
      }),
      type: "badRequest",
      marginInline: "300",
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "xray-recommendation-lib.errors.generalError.message"
        })
      })
    });
  }
}